import Errors from 'common/constants/Errors';
import { isAlphanumericString } from 'common/utils/utils';

export const INTEGRATION_STATES = {
  NOT_ACTIVE: 'Not active'
};

export const PAGE_SIZE = 50;

export const updateIntegrationName =
  (sensorAuthorizationId, gitIntegrations, updateSensorAuthorization) =>
  value => {
    const sensor = gitIntegrations.find(
      ({ id }) => id === sensorAuthorizationId
    );
    const name = value.trim();
    if (sensor && sensor.name !== name) {
      updateSensorAuthorization(sensorAuthorizationId, { name });
    }
  };

export const validateIntegrationName = value => {
  return new Promise((resolve, reject) => {
    if (!value.length) {
      reject(Errors.INTEGRATIONS['EMPTY_NAME']);
    } else if (!isAlphanumericString(value)) {
      reject(Errors.INTEGRATIONS['BAD_NAME']);
    } else {
      resolve();
    }
  });
};
